import { render, staticRenderFns } from "./tabelaListagemCNPJ.vue?vue&type=template&id=2e89e0ba"
import script from "./tabelaListagemCNPJ.vue?vue&type=script&lang=js"
export * from "./tabelaListagemCNPJ.vue?vue&type=script&lang=js"
import style0 from "./tabelaListagemCNPJ.vue?vue&type=style&index=0&id=2e89e0ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports